import React, { useRef, useState } from 'react'
import Sidebar from '../../MainLayout/Sidebar'
import Header from '../../MainLayout/Header'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from 'primereact/button'
import Redemption from './Redemption'
import Discount from './Discount'
import BuisnessLines from './BuisnessLines'
import { createPromo, validatePromo } from '../../Services/Api'
import UserCreation from './UserCreation'
import { Toast } from 'primereact/toast'
import { useNavigate } from 'react-router-dom'
import RegionMain from './RegionMain'

export default function CreateMain() {
    const toast = useRef(null)
    const nav = useNavigate()
    const [couponNameError, setCouponNameError] = useState(false)


    const couponTypes = [
        { label: 'General', value: 'general' },
        { label: 'User Specific', value: 'userspecific' },
        { label: 'Bag Value', value: 'bagvalue' },
        { label: 'Buy x Get Y', value: 'BuyxgetY' },
    ]

    const sourceOptions = [
        { label: 'B2C (CHE/Engage)', value: 'B2C' },
        { label: 'B2B', value: 'B2B' },
        { label: 'D2C', value: 'D2C' },
        { label: 'Central eClinic', value: 'CC' },
    ]


    const yesNoOptions = [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
    ]
    const medicineCategories = ['Rx', 'Nrx', 'Otc', 'Gx']
    const diagnosticCategories = ['Pathology', 'Radiology']

    const levelOptions = ['category', 'manufacturer', 'skus']
    const diagnosticLevelOptions = ['category', 'labs', 'Testcode']

    const [form, setForm] = useState({
        couponName: '',
        couponCode: '',
        description: '',
        couponType: '',
        applyOnMembership: '',
        sourceChannel: '',
        startDate: null,
        endDate: null,
        redeemptions: { perUserLimit: '', totalLimit: '' },
        discount: { discountType: '', range: [] },
        businessLines: {
            lines: [],
            medicines: { level: '', category: [] },
            diagnostics: { level: '', category: [] }
        },
        users: { userTypes: [], patient: [] },
        regions: {
            regionLevel: '',
            zones: [],
            circles: [],
            clusters: [],
            clinics: []
        },
    })

    const [formErrors, setFormErrors] = useState({
        couponName: false,
        couponType: false,
        description: false,
        startDate: false,
        endDate: false,
    });


    console.log(form, "drfghj")

    // Add business line functions that were missing
    const addBusinessLine = () => {
        setForm(prev => ({
            ...prev,
            businessLines: {
                ...prev.businessLines,
                lines: [...prev.businessLines.lines, { line: '', level: '', value: '' }]
            }
        }))
    }

    const updateBusinessLine = (idx, field, value) => {
        setForm(prev => {
            const lines = [...prev.businessLines.lines]
            lines[idx] = { ...lines[idx], [field]: value }
            return {
                ...prev,
                businessLines: { ...prev.businessLines, lines }
            }
        })
    }

    const removeBusinessLine = idx => {
        setForm(prev => {
            const lines = [...prev.businessLines.lines]
            lines.splice(idx, 1)
            return {
                ...prev,
                businessLines: { ...prev.businessLines, lines }
            }
        })
    }


    const checkCouponName = async () => {
        if (!form.couponName.trim()) return
        try {
            const res = await validatePromo(form.couponName.trim())
            console.log('Validation response:', res.data)

            if (res.data === false) {
                setCouponNameError(false)
                toast.current?.show({
                    severity: 'success',
                    summary: 'Valid Coupon Name',
                    detail: 'This coupon name is available.',
                    life: 2000
                })
            } else {
                setCouponNameError(true)
                toast.current?.show({
                    severity: 'error',
                    summary: 'Duplicate Coupon',
                    detail: 'This coupon name already exists. Please try a different one.',
                    life: 3000
                })
            }
        } catch (error) {
            console.error('Validation error:', error)
            setCouponNameError(true)
            toast.current?.show({
                severity: 'warn',
                summary: 'Validation Failed',
                detail: 'Could not validate coupon name. Please try again.',
                life: 3000
            })
        }
    }

    // Handle form field updates
    const handleChange = (path, value) => {
        setForm(prev => {
            const keys = path.split('.')
            const newForm = { ...prev }
            let curr = newForm
            for (let i = 0; i < keys.length - 1; i++) {
                curr[keys[i]] = { ...curr[keys[i]] }
                curr = curr[keys[i]]
            }
            curr[keys[keys.length - 1]] = value
            return newForm
        })
    }

    // Helper to turn either an array or a comma-separated string into a clean array
    function normalize(v) {
        if (Array.isArray(v)) {
            return v.filter(x => !!x);
        }
        if (typeof v === 'string') {
            return v
                .split(',')
                .map(x => x.trim())
                .filter(x => !!x);
        }
        return [];
    }

    function processBusinessLinesForPayload(lines = []) {
        // collect unique line types
        const uniqueLines = [...new Set(lines.map(item => item.line))];

        // initialize
        const medicines = { level: '' };
        const diagnostics = { level: '' };

        lines.forEach(item => {
            const vals = normalize(item.value);

            if (item.line === 'medicines') {
                if (!medicines.level) medicines.level = item.level;

                if (item.level === 'category') {
                    medicines.category = [...(medicines.category || []), ...vals];
                }
                if (item.level === 'manufacturer') {
                    medicines.manufactures = [...(medicines.manufactures || []), ...vals];
                }
                if (item.level === 'skus') {
                    medicines.skus = [...(medicines.skus || []), ...vals];
                }
            }

            if (item.line === 'diagnostics') {
                if (!diagnostics.level) diagnostics.level = item.level;

                if (item.level === 'category') {
                    diagnostics.category = [...(diagnostics.category || []), ...vals];
                }
                if (item.level === 'labs') {
                    diagnostics.labs = [...(diagnostics.labs || []), ...vals];
                }
                if (item.level === 'testcode') {
                    diagnostics.level = 'tests';
                    diagnostics.tests = [...(diagnostics.tests || []), ...vals];
                }
            }
        });

        // dedupe each array field
        ['category', 'manufactures', 'skus'].forEach(key => {
            if (medicines[key]) medicines[key] = [...new Set(medicines[key])];
        });
        ['category', 'labs', 'tests'].forEach(key => {
            if (diagnostics[key]) diagnostics[key] = [...new Set(diagnostics[key])];
        });

        return {
            lines: uniqueLines,
            medicines: medicines.level ? medicines : { level: '' },
            diagnostics: diagnostics.level ? diagnostics : { level: '' }
        };
    }
    const processedBusinessLines = processBusinessLinesForPayload(form.businessLines.lines);
    console.log(processedBusinessLines, "sdcfgvbh")

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    // Build payload and submit
    const handleSubmit = async e => {
        e.preventDefault()
          const userData= localStorage.getItem("userData")
       const parsedUser = JSON.parse(userData);
 
  console.log(parsedUser?.code, "User Code");


        const errors = {
            couponName: !form.couponName.trim(),
            couponType: !form.couponType,
            startDate: !form.startDate,
            endDate: !form.endDate,
            description: !form.description
        };

        setFormErrors(errors);

        const hasError = Object.values(errors).some(Boolean);
        if (hasError || couponNameError) {
            toast.current?.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please fill all required fields.',
                life: 3000
            });
            return;
        }
        if (couponNameError) return

        const processedBusinessLines = processBusinessLinesForPayload(form.businessLines.lines)

        const formatDate = (date) => {
            if (!date) return null
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        }

      
        const payload = {
            couponName: form.couponName,
            couponCode: form.couponName,
            description: form.description,
            couponType: form.couponType,
            applyOnMembership: form.applyOnMembership === 'yes',
            souceChannel: form.sourceChannel,
            startDate: formatDate(form.startDate),
            endDate: formatDate(form.endDate),
            createdBy:parsedUser?.code,
            updatedBy:parsedUser?.code,
            redeemptions: {
                perUserRedeemCnt: Number(form.redeemptions.perUserLimit),
                totalRedeemCnt: Number(form.redeemptions.totalLimit)
            },
            discount: {
                discountType: form.discount.discountType,
                range:

                    [
                        {
                            startRange: form.discount.minPurchase ? Number(form.discount.minPurchase) : 0,
                            endRange: -1,
                            discountValue: Number(form.discount.discountValue),
                            ...(form.discount.discountType === 'percentage' && {
                                maxDiscountAmount: form.discount.maxCap
                                    ? Number(form.discount.maxCap)
                                    : -1,
                            })
                        }
                    ]
            },
            businessLines: processedBusinessLines,
            users: {
                userTypes: form?.users?.userTypes || [],
                patient: form?.users?.patient || []
            },
            regions: {
                regionLevel: form?.regions?.regionLevel || '',
                zones: form?.regions?.zones || [],
                circles: form?.regions?.circles || [],
                clusters: form?.regions?.clusters || [],
                clinics: form?.regions?.clinics || []
            },

        }

        console.log('Payload being sent:', JSON.stringify(payload, null, 2))

        try {
            const res = await createPromo(payload)
            console.log(res?.data, "drftghbj")
            if (res?.data) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Saved',
                    detail: 'Promo created successfully',
                    life: 3000
                })
                nav("/promodashboard")
            }


        } catch (error) {
            console.error('Error creating promo:', error)
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error creating promo',
                life: 3000
            })
        }
    }

    return (
        <div className="flex flex-col md:flex-row h-screen">
            <Toast ref={toast} />
            <Sidebar />
            <div className="flex-1 flex flex-col">
                <Header />
                <main className="p-4 md:p-6 bg-gradient-to-r from-sky-100 to-white flex-1 overflow-auto">
                    <div className="mx-auto bg-white p-8 rounded-3xl shadow-xl">
                        <h2 className="text-3xl font-bold mb-8 text-gray-800 text-center">
                            Create Coupon
                        </h2>
                        <form onSubmit={handleSubmit}>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                <div className="flex flex-col">
                                    <label htmlFor="couponName" className="mb-2 font-semibold text-gray-700">
                                        Coupon Name <span className="text-red-500">*</span>
                                    </label>
                                    <InputText
                                        id="couponName"
                                        value={form.couponName}
                                        onChange={e => {
                                            const raw = e.target.value;
                                            // keep A–Z and 0–9 only, force uppercase
                                            const sanitized = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                            handleChange('couponName', sanitized);
                                            if (couponNameError) setCouponNameError(false);
                                            setFormErrors(prev => ({ ...prev, couponName: false }));

                                        }}
                                        onBlur={checkCouponName}
                                        placeholder="Enter coupon name"
                                        className={`w-full border rounded p-2 ${couponNameError ? 'border-red-500 bg-red-50' : 'border-gray-300'
                                            }`}
                                    />


                                    {formErrors?.couponName && !couponNameError && (
                                        <small className="text-red-500 mt-1">Coupon name is required.</small>
                                    )}
                                    {couponNameError && (
                                        <small className="text-red-500 mt-1">
                                            This coupon name already exists. Please try a different one.
                                        </small>
                                    )}
                                </div>





                                <div className="flex flex-col">
                                    <label htmlFor="couponType" className="mb-2 font-semibold text-gray-700">
                                        Coupon Type <span className="text-red-500">*</span>
                                    </label>
                                    <Dropdown
                                        id="couponType"
                                        value={form.couponType}
                                        options={couponTypes}
                                        onChange={e => {
                                            handleChange('couponType', e.value);
                                            setFormErrors(prev => ({ ...prev, couponType: false }));
                                        }}
                                        // onChange={e => handleChange('couponType', e.value)}
                                        placeholder="Select type"
                                        className="w-full border border-gray-300 rounded p-0"
                                    />
                                    {formErrors.couponType && (
                                        <small className="text-red-500 mt-1">Coupon type is required.</small>
                                    )}
                                </div>

                                <div className="flex flex-col">
                                    <label htmlFor="applyOnMembership" className="mb-2 font-semibold text-gray-700">
                                        Apply on Membership?
                                    </label>
                                    <Dropdown
                                        id="applyOnMembership"
                                        value={form.applyOnMembership}
                                        options={yesNoOptions}
                                        onChange={e => handleChange('applyOnMembership', e.value)}
                                        placeholder="Choose option"
                                        className="w-full border border-gray-300 rounded"
                                    />
                                </div>

                                <div className="flex flex-col lg:col-span-3">
                                    <label htmlFor="description" className="mb-2 font-semibold text-gray-700">
                                        Description <span className="text-red-500">*</span>
                                    </label>
                                    <InputTextarea
                                        id="description"
                                        value={form.description}
                                        rows={3}
                                        onChange={e => {
                                            handleChange('description', e.target.value);
                                            setFormErrors(prev => ({ ...prev, description: false }));
                                        }}
                                        placeholder="Enter description"
                                        className="w-full border border-gray-300 rounded p-2"
                                    />
                                    {formErrors.description && (
                                        <small className="text-red-500 mt-1">Description is required.</small>
                                    )}
                                </div>

                                <div className="flex flex-col">
                                    <label htmlFor="startDate" className="mb-2 font-semibold text-gray-700">
                                        Start Date <span className="text-red-500">*</span>
                                    </label>
                                    <Calendar
                                        id="startDate"
                                        value={form?.startDate}
                                        onChange={e => {
                                            handleChange('startDate', e.value);
                                            setFormErrors(prev => ({ ...prev, startDate: false }));
                                        }}
                                        dateFormat="yy-mm-dd"
                                        showIcon
                                        minDate={today} // 🔒 prevents past date selection
                                        className={`w-full border rounded p-2 ${formErrors?.startDate ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                    />

                                    {formErrors?.startDate && (
                                        <small className="text-red-500 mt-1">Start date is required.</small>
                                    )}
                                </div>

                                <div className="flex flex-col">
                                    <label htmlFor="endDate" className="mb-2 font-semibold text-gray-700">
                                        End Date <span className="text-red-500">*</span>
                                    </label>
                                    <Calendar
                                        id="endDate"
                                        value={form?.endDate}
                                        onChange={e => {
                                            handleChange('endDate', e.value);
                                            setFormErrors(prev => ({ ...prev, endDate: false }));
                                        }}
                                        dateFormat="yy-mm-dd"
                                        showIcon
                                        minDate={form?.startDate || today} // 🔒 depends on selected startDate
                                        className={`w-full border rounded p-2 ${formErrors?.endDate ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                                    />


                                    {formErrors?.endDate && (
                                        <small className="text-red-500 mt-1">End date is required.</small>
                                    )}
                                </div>


                                <div className='flex flex-col'>
                                    <label htmlFor="sourceChannel" className="mb-2 font-semibold text-gray-700">
                                        Source Channel
                                    </label>
                                    <Dropdown
                                        id="sourceChannel"
                                        value={form?.sourceChannel}
                                        options={sourceOptions}
                                        onChange={e => handleChange('sourceChannel', e.value)}
                                        placeholder="Select source channel"
                                        className="w-full border border-gray-300 rounded p-0"
                                    />
                                </div>
                            </div>

                            <div className="col-span-full flex flex-col items-start gap-6 mt-6">
                                <div className="flex-1 w-full ">
                                    <Redemption form={form} handleChange={handleChange} />
                                </div>
                                <div className="flex-1 w-full ">
                                    <Discount form={form} handleChange={handleChange} />
                                </div>

                            </div>

                            <div className="w-full mt-6">
                                <BuisnessLines
                                    form={form}
                                    handleChange={handleChange}
                                    addBusinessLine={addBusinessLine}
                                    updateBusinessLine={updateBusinessLine}
                                    removeBusinessLine={removeBusinessLine}
                                    medicineCategories={medicineCategories}
                                    levelOptions={levelOptions}
                                    diagnosticCategories={diagnosticCategories}
                                    diagnosticLevelOptions={diagnosticLevelOptions}
                                />
                            </div>

                            {form.couponType === 'userspecific' && (
                                <div className="w-full mt-6">
                                    <UserCreation form={form} handleChange={handleChange} />
                                </div>
                            )}
                            {form.sourceChannel === 'B2C' && (
                                <div className="w-full">
                                    <RegionMain form={form} handleChange={handleChange} />
                                </div>
                            )}




                            <div className="col-span-full mt-6">
                                <Button
                                    type="submit"
                                    label="Save Coupon"
                                    disabled={couponNameError}
                                    className="w-full bg-gradient-to-r from-teal-400 to-blue-500 hover:from-teal-500 hover:to-blue-600 text-white font-semibold py-3 rounded-lg shadow-lg transition-colors duration-200"
                                />
                            </div>
                        </form>
                    </div>
                </main>
            </div>
        </div>
    )
}